import { render, staticRenderFns } from "./zarinPal.vue?vue&type=template&id=85b3a344"
import script from "./zarinPal.vue?vue&type=script&lang=js"
export * from "./zarinPal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports